import { Box, Card } from '@material-ui/core';
import styled from 'styled-components';
import { diffuseGlass } from 'styles/mixins';

export const StyledSmallStatisticsContainer = styled(Box)`
    position: absolute;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    display: flex;
    flex-direction: column;
`;

export const StyledToggleBar = styled(Box)`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }) => theme.spacing(0.5, 1)};
    cursor: pointer;
`;

export const StyledStatisticsViewWrapper = styled(Box)<{ $showFade: boolean }>`
    flex: 1;
    padding: ${({ theme }) => theme.spacing(1, 1)};
    overflow-x: hidden;

    mask-image: ${({ $showFade }) =>
        $showFade
            ? 'linear-gradient(to bottom, black 80%, transparent 100%)'
            : 'none'};
`;

export const StyledPanel = styled(Card)`
    position: absolute;
    top: 50%;
    right: 20px;
    z-index: 200;
    display: flex;
    flex-direction: column;
    width: 320px;
    max-height: calc(100% - ${({ theme }) => theme.spacing(4)}px);
    padding: ${({ theme }) => theme.spacing(3, 2)};
    transform: translateY(-50%);
    ${diffuseGlass}
`;
